/*
 * Project: BKN_FRONT
 * Copyright (c) 2024 Nttdata
 */
import axios from "axios";
import { apiUrl } from "../constants/URL";
import { getAuthToken } from "../security/tokenUtils";

const axiosInstance = axios.create({
  baseURL: apiUrl(),
});

axiosInstance.interceptors.request.use(
  (config) => {
    const token = getAuthToken();
    if (token) {
      const newConfig = { ...config };
      newConfig.headers.Authorization = `Bearer ${token}`;
      return newConfig;
    }

    return config;
  },
  (error) => {
    return Promise.reject(error);
  }
);

axiosInstance.interceptors.response.use(
  (response) => response,
  async (error) => {
    const originalRequest = error.config;

    if (error.response) {
      const { status } = error.response;

      if (status === 401 && !originalRequest._retry) {
        //originalRequest._retry = true;
        //There is no refresh token so we cannot refresh here
        return Promise.reject(error);
      }
    }

    return Promise.reject(error);
  }
);

export default axiosInstance;
